<!-- <h1>Enter Mobile Number With Country Code</h1>
{{addbalance}}
<mat-form-field appearance="fill" style="width: 100% !important;">
    <mat-label>Input</mat-label>
    <input matInput type="number" [(ngModel)]="mobileNumber">
  </mat-form-field>
  <div class="example-button-row">
    <button class= "subButton" mat-button color="primary" (click)="submit()">SUBMIT</button>
  </div> -->
<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{this.popup_head}}</h4>
</div>


<div class="modal-body">
  <form>
    <div class="mb-3">
      <!-- <label for="dateOfBirth"
        *ngIf="queryParam.biller != 'SLADigital' && queryParam.id != '490' && queryParam.lang != 'PT'">Enter Mobile
        Number With Country Code :<span style="color: brown;">{{addbalance}}</span></label>
      <label for="dateOfBirth"
        *ngIf="queryParam.biller == 'SLADigital' && (queryParam.id == '490' || queryParam.id == '427') && queryParam.lang == 'PT'">Para
        acessar sua assinatura, digite seu número de celular :<span style="color: brown;">{{addbalance}}</span></label>
      <label for="dateOfBirth"
        *ngIf="queryParam.biller == 'SLADigital' && queryParam.id == '447' && queryParam.lang == 'SG'">Enter Mobile
        Number With Country Code :<span style="color: brown;">{{addbalance}}</span></label>
      <label for="dateOfBirth"
        *ngIf="queryParam.biller == 'ACTEL' && queryParam.id == '528' && queryParam.lang == 'EN'">Enter Mobile
        Number :<span style="color: brown;">{{addbalance}}</span></label> -->
      <label for="dateOfBirth">
        {{this.popup_title}} :<span style="color: brown;">{{addbalance}}</span>
      </label>

      <!-- <div class="input-group">
        <input type="text"
          *ngIf="queryParam.biller != 'SLADigital' && queryParam.id != '490' && queryParam.lang != 'PT'"
          id="dateOfBirth" class="form-control" placeholder="mobile number" name="dp" [(ngModel)]="mobileNumber">
        <input type="text"
          *ngIf="queryParam.biller == 'SLADigital' && (queryParam.id == '490' || queryParam.id == '427') && queryParam.lang == 'PT'"
          id="dateOfBirth" class="form-control" placeholder="258XXXXXXXX" name="dp" [(ngModel)]="mobileNumber">
        <input type="text"
          *ngIf="queryParam.biller == 'SLADigital' && queryParam.id == '447' && queryParam.lang == 'SG'"
          id="dateOfBirth" class="form-control" placeholder="mobile number" name="dp" [(ngModel)]="mobileNumber">
        <input type="text" *ngIf="queryParam.biller == 'ACTEL' && queryParam.operator == '2162'" id="dateOfBirth"
          class="form-control" placeholder="+964" name="dp" [(ngModel)]="mobileNumber"
          (ngModelChange)="onMobileNumberChange($event)" pattern="\+964\d{10}">
      </div> -->

      <div class="input-group mt-3">
        <input type="text"
          *ngIf="queryParam.biller != 'SLADigital' && queryParam.id != '490' && queryParam.lang != 'PT' && !(queryParam.biller == 'ACTEL' && queryParam.operator == '2162')"
          id="dateOfBirth" class="form-control" placeholder="mobile number" name="dp" [(ngModel)]="mobileNumber">

        <input type="text"
          *ngIf="queryParam.biller == 'SLADigital' && (queryParam.id == '490' || queryParam.id == '427') && queryParam.lang == 'PT'"
          id="dateOfBirth" class="form-control" placeholder="258XXXXXXXX" name="dp" [(ngModel)]="mobileNumber">

        <input type="text"
          *ngIf="queryParam.biller == 'SLADigital' && queryParam.id == '447' && queryParam.lang == 'SG'"
          id="dateOfBirth" class="form-control" placeholder="mobile number" name="dp" [(ngModel)]="mobileNumber">

          <div  *ngIf="queryParam.id === '528' && queryParam.biller == 'ACTEL' && queryParam.operator == '2162'">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">+964</span>
              </div>
              <input type="text" id="dateOfBirth" class="form-control" placeholder="XXXXXXXXXX" maxlength="10" name="dp"
                [(ngModel)]="mobileNumber">
            </div>
          </div>
      
      </div>

    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" 
    class="btn btn-primary" (click)="submit()">{{this.popup_btn}}</button>
</div>